function a(t) {
  return t.split("-")[1];
}
export {
  a as default
};
//# sourceMappingURL=getVariation.mjs.map
